import { useTrans } from "src/utils/useTrans";
import SoftwareFeaturesCard from "@/v2-components/pages/software/components/software-features-card";
import { useResponsive } from "@/contexts/ResponsiveProvider";
import {
  SoftwareFeatureData,
  SoftwareFeaturesInfo,
} from "@/v2-components/pages/software/components/software-features-info";

const useSoftwareStudioTrans = () => {
  const { t } = useTrans(["software"]);

  const features: SoftwareFeatureData[] = [
    {
      title: t("Create Audio-To-Haptic Profiles for Customized Experience"),
      body: t(
        "Configure frequency thresholds and customize feedback point mapping to create your own haptic profiles and enjoy customized Audio-to-Haptic experience.",
      ),
      info: [
        t("Frequency band selection"),
        t("Select a sound volume range"),
        t("Real-time Audio & Feedback monitoring"),
      ],
    },

    {
      title: t("Share Audio-to-Haptic Profiles"),
      body: t(
        "Use your Audio-to-Haptic profiles when using the Audio-to-Haptic feature on bHaptics Player and share your profiles with other users.",
      ),
      info: [
        t(
          "Create and upload profiles to bHaptics Player to share with other users",
        ),
      ],
    },
  ];

  return features;
};

export default function StudioFeatures() {
  const desktopImgSrc = (index: number) =>
    `/images/software/studio/software_studio_feature_${index + 1}.jpg`;
  const mobileImgSec = (index: number) =>
    `/images/software/studio/software_studio_feature_${index + 1}_mobile.jpg`;

  const items = useSoftwareStudioTrans();

  if (!items) {
    return null;
  }

  return (
    <section className="w-full px-4 pb-16">
      <div className="mx-auto max-w-[1440px]">
        <div className="flex flex-col gap-y-16">
          {items.map((item, index) => (
            <div key={index} className="h-auto w-full">
              <SoftwareFeaturesCard
                desktopImgSrc={desktopImgSrc(index)}
                mobileImgSec={mobileImgSec(index)}
                isImageRight={!(index === 0 || index % 2 === 0)} // 짝수/홀수 인덱스에 따라 이미지 위치 지정
                contents={<SoftwareFeaturesInfo items={item} />}
                isPriority={index === 0}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
